import { createManagementApi, type ManagementApi } from "./client.js";
import { createFixtureApi } from "./fixtures.js";

/**
 * 既定は同一オリジンの実APIへ接続する（ADR-0011）。
 *
 * 管理画面はAPIと同じWorkerから配信されるため、baseUrlは空文字でよく、
 * `/api/v1` が同一オリジンの相対パスとして解決される。Cloudflare Accessの
 * cookieも同一オリジンのまま送られるので、CORSは不要である。
 *
 * fixtureは開発サーバー（`pnpm run dev`）の既定とする。APIを立てずに画面だけを
 * 触れるようにするためで、本番ビルドでは常に実APIへ接続する。開発中に実APIを
 * 見たいときは `VITE_USE_FIXTURES=false` を指定する。
 */

const baseUrl = import.meta.env.VITE_API_BASE_URL ?? "";

const fixtureFlag = import.meta.env.VITE_USE_FIXTURES;

export const usingFixtures =
  fixtureFlag === undefined ? import.meta.env.DEV : fixtureFlag === "true";

export const api: ManagementApi = usingFixtures
  ? createFixtureApi()
  : createManagementApi(baseUrl);

export { ApiError } from "./client.js";
export type { ManagementApi } from "./client.js";
